import { createWaypoint } from "@utils/intersectionObserverWrapper";

export class ScrollableItems {
  constructor(ctx, wrapper, item) {
    this.ctx = ctx;
    this.wrapper = wrapper;
    this.item = item;

    this.scrollWrapper = this.wrapper.querySelector(".items-scroll-wrapper");
    this.buttonLeft = this.wrapper.querySelector(".js-items-scroll-left");
    this.buttonRight = this.wrapper.querySelector(".js-items-scroll-right");
    this.scrollStep = 100;
  }

  attachEvents() {
    this.checkScrollability();
    window.addEventListener("resize", this.checkScrollability.bind(this)); //uses quite much performance
    this.buttonLeft.addEventListener("click", () => this.scroll(-this.scrollStep));
    this.buttonRight.addEventListener("click", () => this.scroll(this.scrollStep));

    this.initWaypoint();
  }

  initWaypoint() {
    const rightEl = this.scrollWrapper.querySelector(".scroll-offset-right");
    const leftEl = this.scrollWrapper.querySelector(".scroll-offset-left");
    const contextEl = this.scrollWrapper;

    if (rightEl) {
      this.waypointEnd = createWaypoint({
        element: rightEl,
        handler: (direction) => {
          if (direction === "right") {
            this.buttonRight.style.display = "none";
          } else {
            this.buttonRight.style.display = "";
          }
        },
        context: contextEl,
        horizontal: true,
        offset: "right-in-view",
      });
    }

    if (leftEl) {
      this.waypointStart = createWaypoint({
        element: leftEl,
        handler: (direction) => {
          if (direction === "right") {
            this.buttonLeft.style.display = "";
          } else {
            this.buttonLeft.style.display = "none";
          }
        },
        context: contextEl,
        horizontal: true,
      });
    }
  }

  scroll(offset) {
    this.scrollWrapper.scrollBy({ left: offset, behavior: "smooth" });
  }

  checkScrollability() {
    if (this.hasHorizontalScroll(this.scrollWrapper)) {
      this.buttonRight.style.display = "";
    } else {
      this.buttonLeft.style.display = "none";
      this.buttonRight.style.display = "none";
    }
  }

  hasHorizontalScroll(el) {
    return el.scrollWidth > el.clientWidth;
  }
}
